import { useCount } from "@/utils/count";

const load = async () => {
    await useCount().countWww();
    await useCount().countSurvey();
};

export default [
    {
        path: "/cms",
        name: "cms__root__",
        redirect: {
            name: "cms-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            isPublic: true,
            parent: "cms",
            title: "首页",
        },
        beforeEnter: async (to, from, next) => {
            await load();
            next();
        },
        children: [
            {
                path: "index",
                name: "cms-index",
                component: () => import("@/views/cms/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/cms/misc",
        name: "cms-misc",
        meta: {
            title: "全局设置",
            icon: "cms-misc",
            parent: "cms",
            permission: "manage_global_config",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/cms/misc/announcement",
        children: [
            {
                path: "titanconf",
                name: "dev-titanconf",
                component: () => import("@/views/omp/titan/titanconf"),
                meta: {
                    title: "基础配置",
                    icon: "all-setting",
                    affix: false,
                },
            },
            {
                path: "announcement",
                name: "announcement",
                component: () => import("@/views/cms/misc/announcement"),
                meta: {
                    title: "公告管理",
                    icon: "cms-announcement",
                    affix: false,
                },
            },
            {
                path: "menu",
                name: "cms-menu",
                component: () => import("@/views/cms/misc/menu/index.vue"),
                meta: {
                    title: "菜单管理",
                    icon: "cms-menu",
                    affix: false,
                },
            },
            {
                path: "wechat/menu",
                name: "wechat-menu",
                component: () => import("@/views/omp/system/wx_menu.vue"),
                meta: {
                    title: "微信菜单",
                    icon: "cms-wechat-menu",
                },
            },
            {
                path: "dashboard",
                name: "dashboard",
                component: () => import("@/views/cms/misc/dashboard"),
                meta: {
                    title: "后台导航",
                    icon: "cms-dashboard",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/cms/customer",
        name: "cms-customer",
        meta: {
            title: "客户管理",
            icon: "mkt-enterprise",
            parent: "cms",
            permission: "manage_customer",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/cms/customer/organization",
        children: [
            {
                path: "organization",
                name: "cms-enterprise-organization",
                component: () => import("@/views/omp/enterprise/organization.vue"),
                meta: {
                    title: "企业管理",
                    icon: "mkt-organization",
                },
            },
            {
                path: "dashboard",
                name: "cms-enterprise-dashboard",
                component: () => import("@/views/omp/enterprise/dashboard.vue"),
                meta: {
                    title: "园区管理",
                    icon: "mkt-dashboard",
                },
            },
            {
                path: "user",
                name: "cms-account-user",
                component: () => import("@/views/omp/account/user.vue"),
                meta: {
                    title: "账号管理",
                    icon: "mkt-account-user",
                },
            },
            {
                path: "other",
                name: "cms-account-other",
                component: () => import("@/views/omp/account/other-user.vue"),
                meta: {
                    title: "散户管理",
                    icon: "mkt-account-other",
                },
            },
            {
                path: "address",
                name: "cms-customer-address",
                component: () => import("@/views/fms/customer/address.vue"),
                meta: {
                    title: "地址管理",
                    icon: "mkt-address",
                },
            },
            {
                path: "device",
                name: "cms-customer-device",
                component: () => import("@/views/fms/device/log.vue"),
                meta: {
                    title: "设备绑定",
                    icon: "dev-device-all",
                },
            },
        ],
    },
    {
        path: "/cms/general",
        name: "cms-general",
        meta: {
            title: "产品管理",
            icon: "cms-general",
            parent: "cms",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/cms/general/goods_price",
        children: [
            {
                path: "goods_price",
                name: "cms-mall-goods-price",
                component: () => import("@/views/fms/mall/goods_price.vue"),
                meta: {
                    title: "内购产品",
                    icon: "finance-mall-orders",
                    affix: false,
                    permission: "manage_product_price",
                },
            },
            {
                path: "goods_price_detail/:id(\\d+)?",
                name: "cms-mall-goods-price-detail",
                hidden: true,
                component: () => import("@/views/fms/mall/goods_price_detail.vue"),
                meta: {
                    title: "商品详情",
                    affix: false,
                    activeMenu: "/pms/general/goods_price",
                    permission: "manage_product_price",
                },
            },
            {
                path: "goods_price_detail/:id(\\d+)?",
                name: "cms-mall-goods-price-detail",
                hidden: true,
                component: () => import("@/views/fms/mall/goods_price_detail.vue"),
                meta: {
                    title: "商品详情",
                    affix: false,
                    activeMenu: "/cms/general/goods_price",
                    permission: "manage_product_price",
                },
            },
            {
                path: "sim",
                name: "cms-general-sim",
                component: () => import("@/views/fms/general/sim.vue"),
                meta: {
                    title: "流量套餐",
                    icon: "cms-general-sim",
                    affix: false,
                    permission: "manage_general",
                },
            },
            {
                path: "sim-detail/:order_no",
                name: "cms-general-sim-detail",
                component: () => import("@/views/fms/general/sim-record-detail.vue"),
                hidden: true,
                meta: {
                    title: "流量套餐详情",
                    affix: false,
                    activeMenu: "/cms/general/sim",
                },
            },
            {
                path: "package",
                name: "cms-general-titan-package",
                component: () => import("@/views/fms/general/titan-package.vue"),
                meta: {
                    title: "泰坦套餐",
                    icon: "cms-general-titan-package",
                    affix: false,
                    permission: "manage_general",
                },
            },
            {
                path: "package-detail/:order_no",
                name: "cms-general-package-detail",
                component: () => import("@/views/fms/general/package-detail.vue"),
                hidden: true,
                meta: {
                    title: "开通详情",
                    affix: false,
                    activeMenu: "/cms/general/package",
                },
            },
            {
                path: "titan-package/:id(\\d+)",
                name: "cms-titan-package-detail",
                hidden: true,
                component: () => import("@/views/fms/dbmanage/titan-package-detail.vue"),
                meta: {
                    title: "套餐数据",
                    affix: false,
                    activeMenu: "/cms/general/package",
                },
            },
            {
                path: "erp-package",
                name: "cms-general-erp-package",
                component: () => import("@/views/fms/general/erp-package.vue"),
                meta: {
                    title: "采收套餐",
                    icon: "erp",
                    affix: false,
                    permission: "manage_general",
                },
            },
            {
                path: "erp-package-detail/:order_no",
                name: "cms-general-erp-package-detail",
                component: () => import("@/views/fms/general/erp-package-detail.vue"),
                hidden: true,
                meta: {
                    title: "开通详情",
                    affix: false,
                    activeMenu: "/cms/general/erp-package",
                },
            },
            {
                path: "erp-package/:id(\\d+)",
                name: "cms-erp-package-detail",
                hidden: true,
                component: () => import("@/views/fms/dbmanage/erp-package-detail.vue"),
                meta: {
                    title: "套餐数据",
                    affix: false,
                    activeMenu: "/cms/general/erp-package",
                },
            },
            {
                path: "expansion",
                name: "cms-general-expansion-system",
                component: () => import("@/views/fms/general/expansion-system.vue"),
                meta: {
                    title: "拓展系统",
                    icon: "cms-general-expansion-system",
                    affix: false,
                    permission: "manage_general",
                },
            },
            {
                path: "product-detail/:order_no?",
                name: "cms-general-product-detail",
                component: () => import("@/views/fms/general/product-detail.vue"),
                hidden: true,
                meta: {
                    title: "开通详情",
                    affix: false,
                    activeMenu: "/cms/general/expansion",
                },
            },
        ],
    },
    {
        path: "/cms/support",
        name: "cms-support",
        component: () => import("@/layouts/default.vue"),
        redirect: "/cms/support/feedback",
        meta: {
            title: "支持中心",
            icon: "mkt-consult",
            parent: "cms",
        },
        beforeEnter: async (to, from, next) => {
            await load();
            next();
        },
        children: [
            {
                path: "survey",
                name: "cms-support-survey",
                component: () => import("@/views/pms/support/survey.vue"),
                meta: {
                    title: "问卷回访",
                    icon: "cms-support-survey",
                },
            },
            {
                path: "survey-detail/:id",
                name: "cms-support-survey-detail",
                component: () => import("@/views/pms/support/survey-detail.vue"),
                hidden: true,
                meta: {
                    title: "问卷详情",
                    activeMenu: "/cms/support/survey",
                },
            },
            {
                path: "feedback",
                name: "cms-support-feedback",
                component: () => import("@/views/dev/support/feedback.vue"),
                meta: {
                    title: "反馈管理",
                    icon: "cms-support-feedback",
                    permission: "manage_feedback",
                },
            },
            {
                path: "feedback-detail/:id(\\d+)",
                name: "cms-support-feedback-detail",
                component: () => import("@/views/dev/support/feedback-detail.vue"),
                hidden: true,
                meta: {
                    title: "反馈管理",
                    permission: "manage_feedback",
                    activeMenu: "/cms/support/feedback",
                },
            },
            {
                path: "create",
                name: "cms-create-after-sales",
                component: () => import("@/views/fms/after-sales/components/workflow-form.vue"),
                meta: {
                    title: "创建售后工单",
                    activeMenu: "/mkt/after-sales/workflows",
                    link: "cms",
                },
                hidden: true,
            },
            {
                path: "acceptance",
                name: "cms-support-acceptance",
                component: () => import("@/views/fms/acceptance/acceptance.vue"),

                meta: {
                    title: "验收管理",
                    icon: "mkt-acceptance",
                    affix: false,
                    keepAlive: true,
                    permission: "manage_order_sold",
                },
            },
            {
                path: "acceptance/create",
                name: "cms-acceptance-create",
                component: () => import("@/views/fms/acceptance/acceptance-form.vue"),
                props: true,
                meta: {
                    title: "新建验收",
                    activeMenu: "/cms/support/acceptance",
                },
                hidden: true,
            },
        ],
    },
    {
        path: "/cms/msg",
        name: "cms-msg",
        meta: {
            title: "消息中心",
            icon: "cms-message",
            parent: "cms",
            permission: "manage_msg",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "cms-msg-message",
        },
        children: [
            {
                path: "message",
                name: "cms-msg-message",
                component: () => import("@/views/omp/msg/message/index.vue"),
                meta: {
                    title: "私信管理",
                    icon: "cms-msg-message",
                },
            },
            {
                path: "email",
                name: "cms-msg-email",
                component: () => import("@/views/omp/msg/email/index.vue"),
                meta: {
                    title: "邮件管理",
                    icon: "cms-email",
                },
            },

            {
                path: "email/detail",
                name: "cms-msg-email-detail",
                hidden: true,
                component: () => import("@/views/omp/msg/email/email_detail"),
                meta: {
                    title: "发送邮件",
                    affix: false,
                },
            },
            {
                path: "wxmsg",
                name: "cms-msg-wxmsg",
                component: () => import("@/views/omp/msg/wxmsg/index.vue"),
                meta: {
                    title: "微信管理",
                    icon: "cms-wechat-menu",
                },
            },
            {
                path: "phmsg",
                name: "cms-phone-msg",
                component: () => import("@/views/omp/msg/phmsg/index.vue"),
                meta: {
                    title: "短信管理",
                    icon: "cms-phone-msg",
                },
            },
        ],
    },
    {
        path: "/cms/content",
        name: "cms-content",
        meta: {
            title: "官网管理",
            icon: "cms-www",
            parent: "cms",
            permission: "manage_content",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "cms-page",
        },
        children: [
            {
                path: "types",
                name: "cms-productionTypes",
                component: () => import("@/views/cms/product/productionTypes"),
                meta: {
                    title: "产品类型",
                    icon: "cms-production-types",
                    affix: false,
                },
            },
            {
                path: "list",
                name: "cms-productionList",
                component: () => import("@/views/cms/product/productionList"),
                meta: {
                    title: "产品管理",
                    icon: "cms-production",
                    affix: false,
                    keepAlive: true,
                },
            },
            {
                path: "view/:id(\\d+)?",
                name: "cms-product",
                hidden: true,
                component: () => import("@/views/cms/product/product.vue"),
                meta: {
                    title: "产品内容",
                    affix: false,
                },
            },
            {
                path: "page",
                name: "cms-page",
                component: () => import("@/views/cms/content/page"),
                meta: {
                    title: "页面管理",
                    icon: "cms-page",
                    affix: false,
                },
            },
            {
                path: "page/:id(\\d+)+",
                name: "cms-pageDetail",
                hidden: true,
                component: () => import("@/views/cms/content/detail"),
                meta: {
                    title: "页面详情",
                    affix: false,
                },
            },
            {
                path: "/page/:pageId(\\d+)+/meta/:metaId(\\d+)?",
                name: "cms-metaDetail",
                hidden: true,
                component: () => import("@/views/cms/content/meta"),
                meta: {
                    title: "属性详情",
                    affix: false,
                },
            },
            {
                path: "block",
                name: "cms-block",
                component: () => import("@/views/cms/content/block"),
                meta: {
                    title: "模块管理",
                    icon: "mkt-block",
                    affix: false,
                },
            },
            {
                path: "block/:id(\\d+)+",
                name: "cms-blockDetail",
                hidden: true,
                component: () => import("@/views/cms/content/block_detail"),
                meta: {
                    title: "模块详情",
                    affix: false,
                    activeMenu: "/cms/content/block",
                },
            },
            {
                path: "attachment",
                name: "cms-attachment",
                component: () => import("@/views/cms/content/attachment"),
                meta: {
                    title: "附件管理",
                    icon: "cms-attachment",
                    affix: false,
                    keepAlive: true,
                },
            },
            {
                path: "article",
                name: "cms-content-article",
                component: () => import("@/views/cms/content/article"),
                meta: {
                    title: "文章管理",
                    icon: "cms-content-article",
                    affix: false,
                    keepAlive: false,
                },
            },
            {
                path: "article-form/:id(\\d+)?",
                name: "cms-content-article-form",
                hidden: true,
                component: () => import("@/views/cms/content/article_form"),
                meta: {
                    title: "文章内容",
                    affix: false,
                    activeMenu: "/cms/content/article",
                },
            },
        ],
    },
    {
        path: "/cms/intelligence",
        name: "cms-intelligence",
        meta: {
            title: "智能小莓",
            icon: "cms-intelligence",
            parent: "cms",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "cms-intelligence-keywords",
        },
        children: [
            {
                path: "keywords",
                name: "cms-intelligence-keywords",
                component: () => import("@/views/cms/intelligence/keywords.vue"),
                meta: {
                    title: "关键词",
                    icon: "cms-intelligence-keywords",
                },
            },
            {
                path: "keyword-detail/:id",
                name: "intelligence-keyword-detail",
                component: () => import("@/views/cms/intelligence/keyword-detail.vue"),
                hidden: true,
                meta: {
                    title: "策略详情",
                    activeMenu: "/cms/intelligence/keywords",
                },
            },
            {
                path: "keyword-edit/:id?",
                name: "intelligence-keyword-edit",
                component: () => import("@/views/cms/intelligence/keyword-edit.vue"),
                hidden: true,
                meta: {
                    title: "策略详情",
                    activeMenu: "/cms/intelligence/keywords",
                },
            },
            {
                path: "vocabulary",
                name: "intelligence-vocabulary",
                component: () => import("@/views/cms/intelligence/vocabulary.vue"),
                meta: {
                    title: "语音词",
                    icon: "cms-intelligence-vocabulary",
                },
            },
            {
                path: "rag",
                name: "intelligence-rag",
                component: () => import("@/views/cms/intelligence/rag.vue"),
                meta: {
                    title: "知识库",
                    icon: "cms-intelligence-rag",
                },
            },
            {
                path: "rag-detail/:id",
                name: "intelligence-rag-detail",
                component: () => import("@/views/cms/intelligence/rag-detail.vue"),
                hidden: true,
                meta: {
                    title: "知识库详情",
                    activeMenu: "/cms/intelligence/rag",
                },
            },
            {
                path: "chat",
                name: "intelligence-chat",
                component: () => import("@/views/cms/intelligence/chat.vue"),
                meta: {
                    title: "语料库",
                    icon: "cms-intelligence-chat",
                },
            },
            {
                path: "chat-edit/:id?",
                name: "intelligence-chat-edit",
                component: () => import("@/views/cms/intelligence/chat-edit.vue"),
                hidden: true,
                meta: {
                    title: "语料详情",
                    activeMenu: "/cms/intelligence/chat",
                },
            },
            {
                path: "history",
                name: "intelligence-history",
                component: () => import("@/views/cms/intelligence/history.vue"),
                meta: {
                    title: "历史会话",
                    icon: "cms-history",
                },
            },
            {
                path: "history-detail/:id",
                name: "intelligence-history-detail",
                component: () => import("@/views/cms/intelligence/history-detail.vue"),
                hidden: true,
                meta: {
                    title: "会话详情",
                    activeMenu: "/cms/intelligence/history",
                },
            },
            {
                path: "vocabulary-detail/:id",
                name: "intelligence-vocabulary-detail",
                component: () => import("@/views/cms/intelligence/vocabulary-detail.vue"),
                hidden: true,
                meta: {
                    title: "语音热词详情",
                    activeMenu: "/cms/intelligence/vocabulary",
                },
            },
            {
                path: "category",
                name: "cms-intelligence-category",
                component: () => import("@/views/cms/intelligence/category.vue"),
                hidden: true,
                meta: {
                    title: "类型配置",
                    activeMenu: "/cms/intelligence/keywords",
                },
            },
            {
                path: "file",
                name: "cms-intelligence-file",
                component: () => import("@/views/cms/intelligence/file.vue"),
                meta: {
                    title: "文件管理",
                    icon: "cms-oss",
                },
            },
            {
                path: "overview",
                name: "intelligence-overview",
                component: () => import("@/views/cms/intelligence/overview.vue"),
                meta: {
                    title: "统计分析",
                    icon: "cms-stat",
                },
            },
        ],
    },
    {
        path: "/cms/document",
        name: "cms-document",
        meta: {
            title: "文档中心",
            icon: "cms-document",
            parent: "cms",
            permission: "manage_documentation",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "documentCommonList",
        },
        children: [
            {
                path: "common",
                name: "documentCommonList",
                component: () => import("@/views/cms/source/document"),
                meta: {
                    title: "公共文档",
                    icon: "cms-intelligence-rag",
                    affix: false,
                    type: "common",
                },
            },
            {
                path: "titan",
                name: "documentTitanList",
                component: () => import("@/views/cms/source/document"),
                meta: {
                    title: "泰坦文档",
                    icon: "cms-titan-document",
                    affix: false,
                    type: "titan",
                },
            },
            {
                path: "aoms",
                name: "documentAomsList",
                component: () => import("@/views/cms/source/document"),
                meta: {
                    title: "AOMS文档",
                    icon: "cms-document",
                    affix: false,
                    type: "aoms",
                },
            },
            {
                path: "erp",
                name: "documentErpList",
                component: () => import("@/views/cms/source/document"),
                meta: {
                    title: "电子秤文档",
                    icon: "cms-device-document",
                    affix: false,
                    type: "erp",
                },
            },
            {
                path: "device",
                name: "documentDeviceList",
                component: () => import("@/views/cms/source/document"),
                meta: {
                    title: "设备文档",
                    icon: "cms-device-document",
                    affix: false,
                    type: "device",
                },
            },
            {
                path: "detail/:id(\\d+)?",
                name: "document",
                hidden: true,
                component: () => import("@/views/cms/source/document/document_form2.vue"),
                meta: {
                    title: "文档内容",
                    affix: false,
                },
            },
            {
                path: "guide",
                name: "guide",
                component: () => import("@/views/cms/source/guide"),
                meta: {
                    title: "标准指引",
                    icon: "cms-guide",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/cms/resource",
        name: "cms-resource",
        component: () => import("@/layouts/default.vue"),
        redirect: "/cms/resource/file",
        meta: {
            title: "资源中心",
            icon: "cms-resource",
            parent: "cms",
            permission: "manage_resource",
        },
        children: [
            // {
            //     path: "index",
            //     name: "resource",
            //     component: () => import("@/views/cms/resource/index"),
            //     meta: {
            //         title: "文件管理",
            //         icon: "oss",
            //         affix: false,
            //     },
            // },
            {
                path: "file",
                name: "cms-resource-file",
                component: () => import("@/views/cms/oss/file-mng.vue"),
                meta: {
                    title: "文件管理",
                    icon: "cms-oss",
                    affix: false,
                },
            },
            {
                path: "aigrow-icons",
                name: "aigrow-icons",
                component: () => import("@/views/omp/aigrow/icons"),
                meta: {
                    title: "相册图标",
                    icon: "cms-aigrow-icons",
                    affix: false,
                },
            },
            {
                path: "sensor-icons",
                name: "sensor-icons",
                component: () => import("@/views/omp/sensor/icons"),
                meta: {
                    title: "属性图标",
                    icon: "cms-sensor-icons",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/cms/account",
        name: "cms-account",
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "cms-account-list",
        },
        meta: {
            title: "系统账号",
            icon: "cms-account",
            parent: "cms",
            permission: "manage_admin_account",
        },
        children: [
            {
                path: "list",
                name: "cms-account-list",
                component: () => import("@/views/dev/account/list.vue"),
                meta: {
                    title: "账号配置",
                    icon: "cms-account-users",
                    app: "cms",
                },
            },
            {
                path: "role",
                name: "cms-account-role",
                component: () => import("@/views/dev/account/role.vue"),
                meta: {
                    title: "角色配置",
                    icon: "cms-account-role",
                    group: 512,
                },
            },
            {
                path: "permission",
                name: "cms-account-permission",
                component: () => import("@/views/dev/account/permission.vue"),
                meta: {
                    title: "权限配置",
                    icon: "cms-account-permission",
                    group: 512,
                },
            },
        ],
    },
    {
        path: "/cms/log",
        name: "cms-log",
        meta: {
            title: "系统管理",
            icon: "all-system",
            parent: "cms",
            permission: "manage_system_log",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "cms-dev-action-log",
        },
        children: [
            {
                path: "dev-action-log",
                name: "cms-dev-action-log",
                component: () => import("@/views/dev/system/action_log.vue"),
                meta: {
                    title: "操作日志（后台）",
                    icon: "cms-dev-action-log",
                },
            },
            {
                path: "omp-action-log",
                name: "cms-omp-action-log",
                component: () => import("@/views/omp/system/action_log.vue"),
                meta: {
                    title: "操作日志（用户）",
                    icon: "cms-omp-action-log",
                },
            },
            {
                path: "cms-upload-log",
                name: "cms-upload-log",
                component: () => import("@/views/dev/system/upload_log.vue"),
                meta: {
                    title: "上传日志（后台）",
                    icon: "cms-upload-log",
                },
            },
            {
                path: "omp-upload-log",
                name: "cms-omp-upload-log",
                component: () => import("@/views/omp/system/upload_log.vue"),
                meta: {
                    title: "上传日志（用户）",
                    icon: "cms-omp-upload-log",
                },
            },
            {
                path: "sms-log",
                name: "cms-omp-sms-log",
                component: () => import("@/views/omp/system/sms_log.vue"),
                meta: {
                    title: "短信日志",
                    icon: "cms-omp-sms-log",
                },
            },
        ],
    },
];
